import React from 'react'
import Button from 'components/Button'
import { StyledSibarList } from '../Actions.style'

export interface Props {
	handleAction: Function
	actionLabel: string
	actionIcon: any
}

const ListAction = ({ handleAction, actionLabel, actionIcon }: Props) => {
	return (
		<StyledSibarList data-testid="DetailsHeader">
			<Button onClick={handleAction} variant="text" isInput>
				{actionIcon} {actionLabel}
			</Button>
		</StyledSibarList>
	)
}

export default ListAction
